import { useTranslation } from 'react-i18next';
import { useNotices } from '@/hooks/useNotices';
import { useCompanyInfo } from '@/hooks/useCompanyInfo';

export default function TopInfoBar() {
  const { t } = useTranslation('home');
  const { activeTexts } = useNotices();
  const { info } = useCompanyInfo();

  const fallback = [
    t('topBar.notice1') || 'Global sourcing from 500+ verified suppliers across 40 countries',
    t('topBar.notice2') || 'ISO 9001 & GMP certified manufacturing partners',
  ];

  const notices = activeTexts.length > 0 ? activeTexts : fallback;

  return (
    <div className="relative w-full bg-ink-800 text-white/80 text-xs md:text-sm border-b border-ink-700">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="flex items-center justify-between h-9 md:h-10">
          {/* Left: Marquee Notices */}
          <div className="flex items-center gap-3 overflow-hidden min-w-0">
            <div className="relative overflow-hidden h-4 md:h-5 w-full max-w-[280px] sm:max-w-[420px] md:max-w-[560px]">
              <div className="flex whitespace-nowrap animate-marquee">
                {[...notices, ...notices].map((notice, index) => (
                  <span key={index} className="flex items-center gap-6 md:gap-8 shrink-0">
                    <span className="text-white/70">{notice}</span>
                    <span className="text-warm-500/60">|</span>
                  </span>
                ))}
              </div>
            </div>
          </div>

          {/* Right: Contact Info */}
          <div className="hidden md:flex items-center gap-5 lg:gap-7 shrink-0">
            <a
              href={`mailto:${info.email}`}
              className="flex items-center gap-1.5 hover:text-warm-400 transition-colors whitespace-nowrap"
            >
              <i className="ri-mail-line text-xs text-warm-500" />
              <span>{info.email}</span>
            </a>
            <a
              href={`tel:${info.phoneKr.replace(/\s/g, '')}`}
              className="flex items-center gap-1.5 hover:text-warm-400 transition-colors whitespace-nowrap"
            >
              <i className="ri-phone-line text-xs text-warm-500" />
              <span>{info.phoneKr}</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}